import React, { useState } from "react";
import "../../../../../Assets/Styles/CandidatesCard.scss";
import CandidateCard from "./CandidateCard";
import JpaCard from "./JpaCard";

const Candidates = (props) => {
  const [FlipCount, setFlipCount] = useState(0);
  const [CurrentOpenedCardIndex, setCurrentOpenedCardIndex] = useState(-1);
  const handleAddFlipCount = (idx) => {
    setCurrentOpenedCardIndex(idx);
    setFlipCount((prevFlipCount) => prevFlipCount + 1);
  };
  return (
    <div className="candidates-container">
      {props.isJpa
        ? props.Recommendations?.map((jpa, idx) => (
            <JpaCard
              jpa={jpa}
              key={idx}
              LangData={props.LangData}
              handleJpaSave={props.handleJpaSave}
              JPAType={props.JPAType}
              JPACategoryType={props.JPACategoryType}
              handleJpaApply={props.handleJpaApply}
              handleJpaMoreDetail={props.handleJpaMoreDetail}
              SetDetailsIsOpen={(Bool, JPAItem) =>
                props.SetDetailsIsOpen(Bool, JPAItem)
              }
              RefreshRecommendations={() => props.RefreshRecommendations()}
              ChangedJPAReaction={props.ChangedJPAReaction}
            />
          ))
        : props.Recommendations?.map((candidate, idx) => (
            <div key={candidate.name} className="candidate-card">
              <CandidateCard
                candidate={candidate}
                LangData={props.LangData}
                savedContents={props.savedContents}
                handleJpaSave={props.handleJpaSave}
                handleJpaApply={props.handleJpaApply}
                UniqueTitles={props.UniqueTitles}
                JPAType={props.JPAType}
                FlipCount={FlipCount}
                AddFlipCount={handleAddFlipCount}
                CardIdx={idx}
                IsCardSavedOpened={CurrentOpenedCardIndex === idx}
                ChangedCandidateBookmark={props.ChangedCandidateBookmark}
                SavedRequestId={props.SavedRequestId}
                ShowError={(bool) => props.ShowError(bool)}
              />
            </div>
          ))}
    </div>
  );
};

export default Candidates;
